import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { BILLING_TYPE, DataType, IAggregatedChargeItemsInfo, IChargeItemsInfo, IFilter } from "@comunicare/comunicare-interfaces";
import { forkJoin, Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { hasOwnProperty } from "vega";
import { BillingService } from "../../services/billing.service";

@Component({
  selector: "app-invoice-summary",
  templateUrl: "./invoice-summary.component.html",
  styleUrls: ["./invoice-summary.component.scss"],
})
export class InvoiceSummaryComponent implements OnChanges, OnDestroy {
  public DATA_TYPE = DataType;
  public BILLING_TYPE = BILLING_TYPE;

  @Input() pageNumber: number;
  @Input() pageSize: number;
  @Input() services: string[];
  @Input() visibleData: IChargeItemsInfo[] | IAggregatedChargeItemsInfo[];

  protected onDestroy$ = new Subject<void>();

  public billableVisible: number;
  public billableTotal: number;
  public plannedVisible: number;
  public plannedTotal: number;

  constructor(private billingService: BillingService) {}
  ngOnChanges(_changes: SimpleChanges): void {
    this.loadBillingData();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  loadBillingData(): void {
    const billableTotal$ = this.fetchTotal(BILLING_TYPE.BILLABLE);
    const plannedTotal$ = this.fetchTotal(BILLING_TYPE.PLANNED);
    let status: BILLING_TYPE[] = [];

    if (this.visibleData?.length) {
      if (hasOwnProperty(this.visibleData[0], "status")) {
        status = (this.visibleData as IChargeItemsInfo[]).map((data) => data.status);
      } else {
        (this.visibleData as IAggregatedChargeItemsInfo[]).forEach((patientData) => {
          status.push(...patientData.chargeItems?.map((data) => data.status));
        });
      }
    }

    const billableVisible = status.filter((s) => s === BILLING_TYPE.BILLABLE);
    const plannedVisible = status.filter((s) => s === BILLING_TYPE.PLANNED);

    forkJoin([billableTotal$, plannedTotal$])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(([billableTotal, plannedTotal]) => {
        this.billableTotal = billableTotal.count;
        this.plannedTotal = plannedTotal.count;
        this.billableVisible = billableVisible.length;
        this.plannedVisible = plannedVisible.length;
      });
  }

  fetchTotal(status: string): Observable<{ count: number }> {
    const filters: IFilter[] = [
      {
        data: { value: [status] },
        propertyName: "billingStatus",
        dataType: this.DATA_TYPE.CHOICE,
        translateKey: "table.status",
      },
    ];

    return this.billingService.getInvoicesCount(this.services, filters);
  }

  fetchVisible(status: string): Observable<any[]> {
    const filters: IFilter[] = [
      {
        data: { value: [status] },
        propertyName: "billingStatus",
        dataType: this.DATA_TYPE.CHOICE,
        translateKey: "table.status",
      },
    ];

    return this.billingService.findInvoices({
      filters: filters,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      services: this.services,
    });
  }
}
